var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 341.33,
    style: {
      fill: "#73AF00"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("rect", {
    y: 170.67,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD5A"
    },
    d: "M211.842,304.133c5.602-2.823,8.88-7.474,10.632-10.833c10.036,6.556,18.635,4.329,23.116,2.233   c4.373-2.048,7.973-5.39,10.376-8.795c2.404,3.405,6.004,6.747,10.376,8.795c4.479,2.097,13.079,4.32,23.116-2.233   c1.752,3.358,5.03,8.009,10.632,10.833c3.23,1.627,6.789,2.443,10.653,2.443c3.968,0,8.255-0.86,12.833-2.576l-2.223-5.931   c-7.283,2.731-13.46,2.879-18.355,0.436c-6.85-3.414-9.136-10.944-9.155-11.006l-1.336-4.676l-3.736,3.111   c-6.59,5.489-13.415,6.834-19.743,3.862c-6.427-3.009-9.896-9.101-9.896-10.928v-27.332c1.37-3.015,4.394-5.126,7.916-5.126   c1.211,0,2.407,0.263,3.555,0.779l3.92,1.769l-0.592-4.261c-1.243-8.952-8.966-15.703-17.965-15.703s-16.722,6.751-17.965,15.703   l-0.592,4.261l3.92-1.769c1.147-0.516,2.344-0.779,3.555-0.779c3.522,0,6.546,2.111,7.916,5.126v27.332   c0,1.828-3.468,7.92-9.896,10.928c-6.325,2.972-13.153,1.63-19.743-3.862l-3.706-3.071l-1.362,4.623   c-0.022,0.074-2.308,7.604-9.158,11.018c-4.898,2.443-11.074,2.298-18.355-0.436L188.355,304c4.578,1.716,8.866,2.576,12.833,2.576   C205.051,306.576,208.612,305.759,211.842,304.133z M244.882,241.66c-0.379,0-0.756,0.015-1.132,0.049   c2.12-4.725,6.862-7.966,12.215-7.966s10.095,3.241,12.215,7.966c-4.925-0.433-9.582,1.973-12.215,5.783   C253.535,243.97,249.473,241.66,244.882,241.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD5A"
    },
    d: "M201.13,324.267l2.007,6.005c13.464-4.493,32.72-7.072,52.829-7.072s39.364,2.579,52.829,7.072   l2.007-6.005c-14.086-4.703-34.073-7.4-54.836-7.4S215.216,319.564,201.13,324.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD5A"
    },
    d: "M255.966,310.534c3.301,0.01,6.21-1.952,8.18-4.595c-1.31-0.809-3.059-1.282-5.038-1.527   c0.002-0.073,0.025-0.138,0.025-0.211c0-2.715-1.282-5.059-3.167-6.333c-1.885,1.274-3.167,3.618-3.167,6.333   c0,0.073,0.023,0.138,0.025,0.211c-1.979,0.245-3.728,0.718-5.038,1.527C249.755,308.583,252.664,310.543,255.966,310.534z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD5A"
    },
    d: "M226.9,313.527c3.236-0.651,5.695-3.154,7.096-6.138c-1.445-0.531-3.254-0.644-5.242-0.489   c-0.013-0.072-0.003-0.14-0.018-0.212c-0.543-2.66-2.267-4.701-4.369-5.572c-1.592,1.625-2.379,4.179-1.836,6.839   c0.015,0.072,0.05,0.131,0.066,0.202c-1.89,0.636-3.509,1.449-4.631,2.504C220.426,312.858,223.667,314.197,226.9,313.527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD5A"
    },
    d: "M287.564,301.117c-2.102,0.871-3.826,2.912-4.369,5.572c-0.015,0.072-0.005,0.14-0.018,0.212   c-1.988-0.155-3.797-0.042-5.242,0.489c1.402,2.984,3.86,5.487,7.096,6.138c3.233,0.669,6.475-0.669,8.934-2.866   c-1.122-1.055-2.741-1.868-4.631-2.504c0.016-0.071,0.052-0.13,0.066-0.202C289.943,305.295,289.156,302.742,287.564,301.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD5A"
    },
    d: "M255.12,184.491l-2.133,6.396l-6.742,0.052c-0.873,0.007-1.235,1.121-0.533,1.639l5.424,4.005   l-2.034,6.428c-0.263,0.832,0.684,1.521,1.394,1.013l5.485-3.921l5.485,3.921c0.71,0.508,1.658-0.181,1.394-1.013l-2.034-6.428   l5.424-4.005c0.702-0.519,0.34-1.632-0.533-1.639l-6.742-0.052l-2.133-6.396C256.568,183.663,255.396,183.663,255.12,184.491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD5A"
    },
    d: "M216.527,195.046l-2.133,6.396l-6.742,0.052c-0.873,0.007-1.235,1.121-0.533,1.639l5.424,4.005   l-2.034,6.428c-0.263,0.832,0.684,1.521,1.394,1.013l5.485-3.921l5.485,3.921c0.71,0.508,1.658-0.181,1.394-1.013l-2.034-6.428   l5.424-4.005c0.702-0.519,0.34-1.632-0.533-1.639l-6.742-0.052l-2.133-6.396C217.975,194.218,216.803,194.218,216.527,195.046z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD5A"
    },
    d: "M188.16,223.546l-2.133,6.396l-6.742,0.052c-0.873,0.007-1.235,1.121-0.533,1.639l5.424,4.005   l-2.034,6.428c-0.263,0.832,0.684,1.521,1.394,1.013l5.485-3.921l5.485,3.921c0.71,0.508,1.658-0.181,1.394-1.013l-2.034-6.428   l5.424-4.005c0.702-0.519,0.34-1.632-0.533-1.639l-6.742-0.052l-2.133-6.396C189.607,222.718,188.436,222.718,188.16,223.546z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD5A"
    },
    d: "M177.736,262.073l-2.133,6.396l-6.742,0.052c-0.873,0.007-1.235,1.121-0.533,1.639l5.424,4.005   l-2.034,6.428c-0.263,0.832,0.684,1.521,1.394,1.013l5.485-3.921l5.485,3.921c0.71,0.508,1.658-0.181,1.394-1.013l-2.034-6.428   l5.424-4.005c0.702-0.519,0.34-1.632-0.533-1.639l-6.742-0.052l-2.133-6.396C179.184,261.245,178.013,261.245,177.736,262.073z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD5A"
    },
    d: "M295.473,195.046l2.133,6.396l6.742,0.052c0.873,0.007,1.235,1.121,0.533,1.639l-5.424,4.005   l2.034,6.428c0.263,0.832-0.684,1.521-1.394,1.013l-5.485-3.921l-5.485,3.921c-0.71,0.508-1.658-0.181-1.394-1.013l2.034-6.428   l-5.424-4.005c-0.702-0.519-0.34-1.632,0.533-1.639l6.742-0.052l2.133-6.396C294.025,194.218,295.197,194.218,295.473,195.046z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD5A"
    },
    d: "M323.84,223.546l2.133,6.396l6.742,0.052c0.873,0.007,1.235,1.121,0.533,1.639l-5.424,4.005   l2.034,6.428c0.263,0.832-0.684,1.521-1.394,1.013l-5.485-3.921l-5.485,3.921c-0.71,0.508-1.658-0.181-1.394-1.013l2.034-6.428   l-5.424-4.005c-0.702-0.519-0.34-1.632,0.533-1.639l6.742-0.052l2.133-6.396C322.393,222.718,323.564,222.718,323.84,223.546z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD5A"
    },
    d: "M334.264,262.073l2.133,6.396l6.742,0.052c0.873,0.007,1.235,1.121,0.533,1.639l-5.424,4.005   l2.034,6.428c0.263,0.832-0.684,1.521-1.394,1.013l-5.485-3.921l-5.485,3.921c-0.71,0.508-1.658-0.181-1.394-1.013l2.034-6.428   l-5.424-4.005c-0.702-0.519-0.34-1.632,0.533-1.639l6.742-0.052l2.133-6.396C332.816,261.245,333.987,261.245,334.264,262.073z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTj);
export default __webpack_public_path__ + "static/media/tj.84fb4a1cff271a75a6b2df3074288005.svg";
export { ForwardRef as ReactComponent };